import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'grid',
    placeItems: 'center',
    borderRadius: '8px',
    minWidth: '224px',
    width: '300px',
    maxWidth: '300px',
    minHeight: '64px',
    height: '64px',
    maxHeight: '64px',
    background: ({ isYours }) =>
      isYours ? theme.palette.primary.main : 'white'
  },

  content: {
    display: 'flex',
    alignItems: 'center',
    width: 'calc(100% - 32px)'
  },

  icon: {
    marginRight: '8px',
    padding: 6,
    borderRadius: 8,
    backgroundColor: ({ isYours }) => (isYours ? 'white' : '#F5F6F8')
  },

  info: {
    flex: '1',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    maxWidth: '55%',
    cursor: 'default'
  },

  title: {
    maxWidth: '180px',
    fontSize: theme.size.base,
    color: ({ isYours }) => (isYours ? 'white' : 'black'),
    cursor: 'default'
  },

  type: {
    marginTop: '2px',
    fontSize: theme.size.sm,
    opacity: '0.7',
    cursor: 'default'
  }
}))

export default useStyles
